import React from 'react';

import classes from './SearchResultMobileHeading.scss';

const searchResultMobileHeading = (props) => (
    <h3 className={`${classes.Heading} u-fontSize13 u-fontWeightRegular u-width100Percent mr-4 u-textColorDark phone-ml-0`} {...props}>{props.children}</h3>
);

export default searchResultMobileHeading;


// WEBPACK FOOTER //
// ./src/components/UI/Headers/SearchResultHeader/SearchResultMobileHeading/SearchResultMobileHeading.js